import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { getUrlParams } from "../apiService/timespam";
import "./Theme.css";
import "./LifestyleCardInfo.css";

// Maps sid query param (case-insensitive) to i18n key
const CONTENT_KEY = {
  showgoqiiage:        "cardInfo.goqiiAge",
  showagingpace:       "cardInfo.agingPace",
  mygoqiihealth:       "cardInfo.goqiiHealth",
  myhealthjourney:     "cardInfo.healthJourney",
  mygoqiilife:         "cardInfo.goqiiLife",
  myhealthawareness:   "cardInfo.healthAwareness",
  myhealthtimeline:    "cardInfo.healthTimeline",
  distance:            "cardInfo.distance",
  myactivetime:        "cardInfo.activeTime",
  sleepscore:          "cardInfo.sleepScore",
  nutritionawareness:  "cardInfo.nutritionAwareness",
  weighthistory:       "cardInfo.weightHistory",
  hrahistory:          "cardInfo.hraHistory",
};

const LifestyleCardInfo = () => {
  const { t } = useTranslation();
  const { theme, lang } = getUrlParams();
  const sid = new URLSearchParams(window.location.search).get("sid") || "";
  const contentKey = CONTENT_KEY[sid.toLowerCase()] || null;

  useEffect(() => {
    document.documentElement.className = theme === "dark" ? "dark" : "";
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [theme, lang]);

  return (
    <div className="lci-container">
      {contentKey ? (
        <p className="lci-text">{t(contentKey)}</p>
      ) : (
        <p className="lci-text lci-fallback">{t("cardInfo.notFound")}</p>
      )}
    </div>
  );
};

export default LifestyleCardInfo;
